import { zodFallback } from '../../zod/fallback';
import z from 'zod';

/**
 * How the backend determined a location. Mirrors `Constants.NavigationService.Accuracy`.
 */
export const LocationAccuracy = zodFallback(z.enum(['realtime', 'product', 'commodityGroup', 'ticket']), 'unknown');
export type LocationAccuracy = z.infer<typeof LocationAccuracy>;

export function isRealtimeAccuracy(accuracy: LocationAccuracy | null | undefined): boolean {
    return !accuracy || accuracy === 'realtime';
}
